var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 384C14.326 384 0 398.326 0 416V480C0 497.672 14.326 512 32 512S64 497.672 64 480V416C64 398.326 49.674 384 32 384ZM288 192C270.326 192 256 206.326 256 224V480C256 497.672 270.326 512 288 512S320 497.672 320 480V224C320 206.326 305.674 192 288 192ZM160 288C142.326 288 128 302.326 128 320V480C128 497.672 142.326 512 160 512S192 497.672 192 480V320C192 302.326 177.674 288 160 288Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalGood);
export default __webpack_public_path__ + "static/media/signal-good.82aef759cc2f952f2b105984c6272246.svg";
export { ForwardRef as ReactComponent };